<mat-toolbar color="primary" style="max-width: 100%;" fxLayout="row">
    <div fxFlex="1000px" style="overflow-wrap: normal;">
        Code : {{ code?.value }}&nbsp;&nbsp;{{ code?.properties.label }}
    </div>
    <div fxFlex="250px">
        <mat-form-field appearance="legacy" style="height:35px;margin-left:10px;">
            <mat-label>Versions</mat-label>
            <mat-select [value]="currentDate">
                <mat-option *ngFor="let aDate of codeDates" (click)="selectDate(aDate)" [value]="aDate">{{ aDate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</mat-toolbar>
<div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="80px">
        <button mat-icon-button (click)="addCustomField()"><fa-icon [icon]="['fas','plus-circle']" size="2x"></fa-icon></button>
    </div>
    <div fxFlex>
        <span *ngFor="let extra of code?.extras" class="service-code-extra">{{extra.name}}</span>
    </div>
    <div fxFlex="80px">
        <button mat-icon-button (click)="saveCode()"><fa-icon [icon]="['fas','save']" size="2x"></fa-icon></button>
    </div>
</div>
<div *ngIf="code?.key == 'SNItem.CNItem.CNServiceCode.CNServiceCodeINAMI'">
    <app-admin-service-code-value *ngFor="let value of code?.values" [value]="value"></app-admin-service-code-value>
</div>
<div *ngIf="code?.key == 'SNItem.CNItem.CNServiceCode.CNServiceCodeCustom'">
    <app-admin-service-code-value [code]="code"></app-admin-service-code-value>
</div>